export const caseflowOrigin = "https://caseflow.nex-a.net";

export type CaseflowSupportConfig = { siteKey: string; projectId: string; llm: boolean };

export const caseflowSupportConfig = (
  env: Record<string, string | boolean | undefined>,
): CaseflowSupportConfig | null => {
  if (env.VITE_CASEFLOW_WIDGET_ENABLED !== "true") return null;
  const siteKey = String(env.VITE_CASEFLOW_WIDGET_SITE_KEY ?? "").trim();
  const projectId = String(env.VITE_CASEFLOW_WIDGET_PROJECT_ID ?? "").trim();
  if (!/^[a-zA-Z0-9_-]{1,120}$/.test(siteKey)) return null;
  if (!/^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(projectId)) return null;
  return { siteKey, projectId, llm: env.VITE_CASEFLOW_WIDGET_LLM === "true" };
};

// The SDK sends the host URL and can capture the host on explicit user request.
// Keep it off replay, project, MCP and OAuth callback URLs, including sensitive
// query strings/fragments on an otherwise public page.
export const isPublicSupportLocation = (pathname: string, search = "", hash = "") => {
  if (hash || !(pathname === "/login" || /^\/disclosures\/[a-zA-Z0-9_-]{1,120}$/.test(pathname))) return false;
  const params = new URLSearchParams(search);
  return [...params].every(([key, value]) => key === "lang" && ["ja", "en"].includes(value))
    && params.getAll("lang").length <= 1;
};

export const assertCaseflowSupportRouting = (value: unknown, config: CaseflowSupportConfig) => {
  const result = value as { ok?: boolean; siteKey?: string; projectId?: string; projectName?: string; llmReplyEnabled?: boolean } | null;
  if (!result?.ok || result.siteKey !== config.siteKey || result.projectId !== config.projectId
    || result.projectName?.toLowerCase() !== "flowtrace" || result.llmReplyEnabled !== config.llm) {
    throw new Error("CaseFlow support routing is not ready");
  }
};
